module.exports = __webpack_public_path__ + "media/images/banner/planning/id-670144b245418ab18ca18a7397caa034.jpg";